import { corporateModules } from './module.data';
import { CorporateModule } from './module.types';

const moduleRegistry = new Map<string, CorporateModule>(
  corporateModules.map(module => [module.id, module]),
);

export const getCorporateModules = (): CorporateModule[] =>
  Array.from(moduleRegistry.values());

export const getCorporateModule = (
  moduleId: string,
): CorporateModule | undefined => moduleRegistry.get(moduleId);

export const isCorporateModuleRoute = (route: string): boolean =>
  corporateModules.some(module => module.route === route);
